<template>

  <v-layout
    column
    fill-height
  >
    <v-toolbar
      v-if="this.isMobile"
      flat
    >
    </v-toolbar>

    <v-list dark v-if="pageNavigationItems.length > 0">

      <v-list-tile
        v-for="(item, i) in pageNavigationItems"
        :key="i"
        @click="goToPage(item)"
      >

        <v-list-tile-avatar>
          <v-icon
            v-if="pageLocation === item.destination"
            color="primary"
            :class="{'headerTab': item.header === 'true'}"
          >{{item.icon}}</v-icon>
          <v-icon
            :class="{'headerTab': item.header === 'true'}"
            v-else
          >{{item.icon}}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>
          <span
            v-if="item.header"
            style="font-weight:700"
          >{{item.title}}</span>
          <span v-else>{{item.title}}</span>
        </v-list-tile-title>
      </v-list-tile>

    </v-list>

    <v-layout
      v-show="!pageNavigationItems.length > 0"
      v-else
      column
      style="opacity:0.6;"
      class="mx-3 mt-3 mb-2"
    >
      <v-card
        flat
        style="border: 1px solid #E8EAED; border-radius:6px; cursor:pointer"
      >
        <v-card-text>
          <span style="font-weight:700; font-size:18px; margin:10px;">
            About OneChart
          </span>
          <p style="font-size:14px; margin:10px; text-align:justified;">OneChart is a patient-first cloud based medical records platform designed to empower individuals and families to collect, store, and share their medical records in any care setting.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            flat
            color="primary"
            @click.native="goToAbout()"
          >Learn More</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
    <v-spacer></v-spacer>
    <v-list>

      <v-list-tile
        v-for="(item, i) in globalNavigationItems"
        :key="i"
        @click="menuAction(i)"
      >

        <v-list-tile-avatar>
          <v-icon>{{item.icon}}</v-icon>
        </v-list-tile-avatar>
        <span>{{item.title}}</span>

      </v-list-tile>

    </v-list>

    <!-- <v-divider></v-divider> TODO: Recent pages links-->

    <!-- <v-list
      v-if="recentPages.length > 0"
      subheader
    >
      <v-subheader>Recent Pages</v-subheader>

      <v-list-tile
        v-for="(item, i) in recentPages"
        :key="i"
        @click="goToPage(item)"
        :disabled="checkDisabled(item.enabled)"
      >

        <v-list-tile-avatar>
          <img
            style="width:25px;"
            v-if="item.iconURL"
            :src="item.iconURL"
          />
          <v-icon v-else>{{item.icon}}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>
          <span
            v-if="item.header"
            style="font-weight:700"
          >{{item.title}}</span>
          <span v-else>{{item.title}}</span>
        </v-list-tile-title>
      </v-list-tile>

    </v-list> -->
    <upload-files-dialog ref="upload" />
  </v-layout>

</template>

<style lang="scss" scoped>
$font: sans-serif;
$color: #1565c0;
$gender: #666;
$birthdate: #999;
$addr: #1565c0;
$background-gray: rgb(206, 206, 206);

.currentTab {
  color: #4485ed;
  text-align: left;
  opacity: 1;
  background-color: transparent;
  font-size: 15px;
  .v-icon {
    color: #4485ed;
  }
}

.headerTab {
  border: 1px solid #e8eaed;
  background-color: white;
}
.regularTab {
  background-color: transparent;
  text-align: left;
  opacity: 0.6;
  font-size: 18px;
}

.regularTab:hover {
  background-color: white;
  color: blue;
  text-align: left;
  opacity: 1;
  font-size: 18px;

  .v-icon {
    color: #4485ed;
  }
}
</style>
<script>
import { mapActions, mapState } from 'vuex'
import UploadFilesDialog from '@/components/dialogs/UploadFilesDialog'

export default {
  name: 'GlobalNavigationToolbar',
  components: {
    UploadFilesDialog
  },
  props: {
    drawer: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      miniToolbar: false,
      globalNavigationItems: [],
      recentDocuments: [],
      recentPatients: [],
      recentPatientDisplay: [],
      recentPatientsIDs: [],
      recentPages: []
    }
  },
  computed: {
    ...mapState('patient', [
      'patient',
      'files',
      'requests',
      'preliminaryPermissions'
    ]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    pageNavigationItems() {
      let items = []
      items.push({
        title: 'Document Management',
        icon: 'print',
        destination: 'AdminDocumentsPage'
      })
      items.push({
        title: 'Request Management',
        icon: 'send',
        destination: 'AdminRequestsPage'
      })
      // items.push({
      //   title: 'Metrics',
      //   icon: 'trending_up',
      //   destination: 'AdminLandingPage'
      // })
      // items.push({
      //   title: 'Patient Collection',
      //   icon: 'people',
      //   destination: 'AdminPatientsPage'
      // })
      // items.push({
      //   title: 'Provider Collection',
      //   icon: 'local_hospital',
      //   destination: 'AdminProvidersPage'
      // })

      return items
    },
    pageLocation() {
      return this.$route.name
    }
  },
  mounted() {
    let items = [{ title: 'Log Out', icon: 'exit_to_app', method: 'logout()' }]
    this.globalNavigationItems = items
  },
  watch: {
    patient() {
      let id = this.patient._id
      this.getPreliminaryPermissions({ id })
    }
    // $route(to, from) {
    //   debugger
    //   console.log(from)

    //   this.recentPage.push({
    //     title: from,
    //     icon: 'import_export',
    //     destination: from
    //   })
    // }
  },
  methods: {
    ...mapActions('auth', ['getUser', 'signOut']),
    ...mapActions('patient', ['setThePatient', 'getPreliminaryPermissions']),
    selectPatient(patient) {
      let vm = this
      this.setThePatient(patient).then(patient => {
        let pt = patient
        vm.$router.push({
          name: 'PatientPage',
          params: { id: pt._id }
        })
      })
    },
    goToAbout() {
      console.log('go to about')
      window.open('https://www.onecharthealth.com/about-1/')
    },
    openShareDialog() {
      this.$refs.shareChart.open({})
    },
    openUploadDialog() {
      this.$refs.upload.open({})
    },
    buttonColor(title) {
      if (title === this.tabToHighlight) {
        return 'primary'
      }
      return null
    },
    openRequestDialog() {
      this.$refs.request.open({})
    },
    showWelcomeDialog() {
      this.$refs.welcomeDialog.open({
        triggerWelcome: true
      })
    },
    menuAction(index) {
      if (this.globalNavigationItems[index].title === 'Add Patient Chart') {
        this.showWelcomeDialog()
      }
      if (this.globalNavigationItems[index].title === 'Log Out') {
        this.signOut()
        this.$router.push('/login')
      }
      if (this.globalNavigationItems[index].title === 'Account Settings') {
        this.account()
      }
    },
    account() {
      this.$router.push({
        name: 'AccountPage'
      })
    },
    goToPage(item) {
      let paramDestinations = ['PatientPage', 'PatientInfoPage']
      const patient = this.patient._id
      if (
        item.destination.includes('Admin') ||
        item.destination.includes('Account')
      ) {
        this.$router.push({
          name: item.destination
        })
      } else if (paramDestinations.includes(item.destination)) {
        this.$router.push({
          name: item.destination,
          params: { id: patient }
        })
      } else {
        this.$router.push({
          name: item.destination,
          query: { patient }
        })
      }
    },
    navPatients() {
      this.setThePatient({})
      this.$router.push({
        name: 'PatientsPage'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/headers/GlobalNavigationToolbar.vue